export const adInstantLoan = {
    event: "banner_instant_loan",
    eventCategory: "Buy_used_cars_C2C_Car_Listing_Page",
    eventAction: "Buy_used_cars_C2C_Car_Listing_Page"
};
